<template>
  <div v-if="componentVisible" class="reports-preview" @click="change()">
    <div class="row">
      <div class="wrapper">
        <vs-col
          v-if="reportsVisible && deliveryShare > 0"
          class="column"
          vs-w="12"
        >
          <span class="title">هزینه های پیک: </span>
          <span class="value"
            >{{ deliveryShare.toString().numberFormat() }} ریال</span
          >
        </vs-col>
        <vs-col
          v-if="reportsVisible && gatewayPayments > 0"
          class="column"
          vs-w="12"
        >
          <span class="title">مجموع پرداختی آنلاین: </span>
          <span class="value"
            >{{ gatewayPayments.toString().numberFormat() }} ریال</span
          >
        </vs-col>
        <vs-col
          v-if="reportsVisible && upfrontPayments > 0"
          class="column"
          vs-w="12"
        >
          <span class="title">مجموع پرداخت در محل: </span>
          <span class="value"
            >{{ upfrontPayments.toString().numberFormat() }} ریال</span
          >
        </vs-col>
        <vs-col
          v-if="reportsVisible && topMenuShare > 0"
          class="column"
          vs-w="12"
        >
          <span class="title">درآمد تاپ منو از تراکنشهای آنلاین: </span>
          <span class="value"
            >{{ topMenuShare.toString().numberFormat() }} ریال</span
          >
        </vs-col>
        <vs-col class="column" vs-w="12">
          <span class="title">جمع کل دریافتی: </span>
          <span class="value">{{ calculateSum }} ریال</span>
        </vs-col>
      </div>
      <div v-if="reportsVisible" class="wrapper" style="width: 84px">
        <span class="count">تعداد فیش: </span>
        <div class="count-wrapper">
          <span class="value">{{
            receiptCount.toString().numberFormat()
          }}</span>
        </div>
      </div>
      <div v-else class="wrapper" style="width: 84px">
        <span class="count">نمایش کامل</span>
      </div>
    </div>

    <div v-if="tableId" class="warning">
      <p>فیلتر شماره میز گزارش فروش نخواهد داشت.</p>
      <vs-button size="small" color="danger" @click="resetTables"
        >حذف فیلتر</vs-button
      >
    </div>

    <div v-if="reportsVisible" class="footer">
      <download-excel
        class="btn btn-default"
        :data="json_data"
        :fields="json_fields"
        worksheet="My Worksheet"
        :name="excelFileName"
        :meta="json_meta"
      >
        <vs-button size="small">دریافت گزارشات در قالب اکسل</vs-button>
      </download-excel>
    </div>
  </div>
</template>

<script>
import moment from "jalali-moment";
import { mapGetters } from "vuex";
import providerApiService from "../../services/api/ProviderApiService";
import { yearMonths } from "../../helpers/Date";

export default {
  name: "Orders.vue",
  data() {
    return {
      reportsVisible: false,
      componentVisible: false,
      deliveryShare: 0,
      gatewayPayments: 0,
      upfrontPayments: 0,
      topMenuShare: 0,
      json_fields: {
        "از تاریخ": "fromDate",
        "تا تاریخ": "toDate",
        "تعداد فیش": "receiptCount",
        "هزینه های پیک": "deliveryShare",
        "مجموع پرداختی آنلاین": "gatewayPayments",
        "مجموع پرداخت در محل": "upfrontPayments",
        "درآمد تاپ منو از تراکنش های آنلاین": "topMenuShare",
        "جمع کل دریافتی": "sum",
      },
      json_data: [],
      excelFileName: "",
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },
  computed: {
    ...mapGetters({
      currentProvider: "profile/currentProvider",
    }),
    calculateSum() {
      return (this.gatewayPayments + this.upfrontPayments)
        .toString()
        .numberFormat();
    },
  },
  methods: {
    refresh() {
      this.getProviderFinancialReports(this.date);
    },
    getProviderFinancialReports(date) {
      providerApiService
        .getProviderFinancialReports(this.currentProvider.id, date)
        .then((result) => {
          this.deliveryShare = result.deliveryShare;
          this.topMenuShare = result.topMenuShare;
          this.gatewayPayments = result.gatewayPayments;
          this.upfrontPayments = result.upfrontPayments;
          this.configExcelFile(date);
        })
        .catch((e) => (this.error = e))
        .finally(() => (this.loading = false));
    },
    configExcelFile(date) {
      const startDate = moment(date[0]);
      const endDate = moment(date[1]).add(-1, "day");
      const fromDate = `${startDate.jYear()}-${
        yearMonths[startDate.jMonth()]
      }-${startDate.jDate()}`;
      const toDate = `${endDate.jYear()}-${
        yearMonths[endDate.jMonth()]
      }-${endDate.jDate()}`;

      this.json_data = [
        {
          fromDate: fromDate,
          toDate: toDate,
          receiptCount: this.receiptCount,
          deliveryShare: this.deliveryShare,
          gatewayPayments: this.gatewayPayments,
          upfrontPayments: this.upfrontPayments,
          topMenuShare: this.topMenuShare,
          sum:
            this.gatewayPayments +
            this.upfrontPayments +
            this.deliveryShare +
            this.topMenuShare,
        },
      ];
      this.excelFileName =
        "گزارش مالی مجموعه " + this.currentProvider.persian_name + ".xls";
    },
    getEmployeeAbilities() {
      /**
       * This should be changed later
       * Needs specific access
       */
      this.componentVisible = true;
    },
    change() {
      this.reportsVisible = !this.reportsVisible;
    },
    resetTables() {
      this.$emit("resetTables");
    },
  },
  watch: {
    date(value) {
      this.getProviderFinancialReports(value);
    },
  },
  mounted() {
    this.getProviderFinancialReports(this.date);
    this.getEmployeeAbilities();
  },
  props: {
    date: {
      required: true,
      type: Array,
    },
    receiptCount: {
      required: true,
      type: Number,
    },
    tableId: {
      type: [Number, null],
      required: false,
    },
  },
};
</script>

<style scoped lang="scss">
.reports-preview {
  position: sticky;
  bottom: 5%;
  padding: 10px;
  border-radius: 10px;
  max-width: 450px;
  margin: 0 auto;
  background-color: #ffffff;
  cursor: pointer;
  box-shadow: 0 4px 18px 0 rgba(0, 0, 0, 0.12),
    0 7px 10px -5px rgba(0, 0, 0, 0.15);
  transition: opacity 0.3s, transform 0.35s;

  .footer {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    position: relative;
    z-index: 10000;
  }
}

.row {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .column {
    margin: 5px;
    margin-left: 0;
    padding-left: 0;
  }

  .title {
    color: #7d7d7d;
    font-size: 1rem;
    margin-right: 5px;

    @media (max-width: 450px) {
      font-size: 0.8rem;
    }
  }

  .value {
    color: #000000;
    font-size: 1.2rem;
    font-weight: bold;

    @media (max-width: 450px) {
      font-size: 1rem;
    }
  }

  .count-wrapper {
    border: 1px solid #7d7d7d;
    border-radius: 50%;
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 5px;
  }
}

.warning {
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: center;
  color: #ea5455;
  margin-top: 8px;
}
</style>
